<template>
  <div class="stats-grid">
    <div class="stat-card">
      <h4>Total Devices</h4>
      <p class="stat-number">{{ stats.totalDevices }}</p>
    </div>
    <div class="stat-card">
      <h4>Available Now</h4>
      <p class="stat-number">{{ stats.availableDevices }}</p>
    </div>
    <div class="stat-card">
      <h4>In Use</h4>
      <p class="stat-number">{{ stats.inUseDevices }}</p>
    </div>
    <div class="stat-card">
      <h4>Active Users</h4>
      <p class="stat-number">{{ stats.totalUsers }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { COLORS, GRADIENTS } from '@/styles/brand'

const props = defineProps({
  devices: Array,
  users: Array
})

const stats = computed(() => ({
  totalDevices: props.devices?.length || 0,
  availableDevices: props.devices?.filter(d => !d.lastTakenBy).length || 0,
  inUseDevices: props.devices?.filter(d => d.lastTakenBy).length || 0,
  totalUsers: props.users?.length || 0
}))
</script>

<style scoped>
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 32px;
}

.stat-card {
  background: v-bind('GRADIENTS.CARD');
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px;
  border-radius: 16px;
  text-align: center;
}

.stat-card h4 {
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 12px 0;
  font-size: 0.9rem;
  text-transform: uppercase;
}

.stat-number {
  color: v-bind('COLORS.PRIMARY.WHITE');
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0;
}
</style>